import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

// Static data for demonstration
const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'name', headerName: 'Name', width: 150, editable: true },
  { field: 'rating', headerName: 'Rating', width: 150, editable: true },
  { field: 'country', headerName: 'Country', width: 150 },
  { field: 'dateCreated', headerName: 'Date Created', width: 180 },
  { field: 'isAdmin', headerName: 'Is Admin', width: 120 },
];

const rows = [
  { id: 1, name: 'John Doe', rating: 5, country: 'USA', dateCreated: '2023-01-01', isAdmin: true },
  { id: 2, name: 'Jane Smith', rating: 4, country: 'UK', dateCreated: '2023-02-15', isAdmin: false },
  { id: 3, name: 'John Doe', rating: 5, country: 'USA', dateCreated: '2023-01-01', isAdmin: true },
  { id: 4, name: 'Jane Smith', rating: 4, country: 'UK', dateCreated: '2023-02-15', isAdmin: false },
  // Add more rows as needed
];

export default function QuickFilteringGrid() {
  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
      />
    </Box>
  );
}
